export enum ContactsApi {
  Contacts = '/api/v2.0/UserContact',
  ImportFromFilestack = '/api/v2.0/UserContact/import/filestack',
  RecentContacts = '/api/v2.0/UserContact/recent',
  SuggestedContacts = '/api/v2.0/UserContact/suggested',
  SalesforceAccounts = 'api/v2/crm/salesforce/accounts',
  SalesforceStates = 'api/v2/crm/salesforce/states',
  SalesforceCities = 'api/v2/crm/salesforce/cities',
  SalesforceContacts = 'api/v2/crm/salesforce/contacts',
  HubspotContacts = '/api/v2/crm/hubspot/contacts',
  HubspotCompanies = '/api/v2/crm/hubspot/companies',
  HubspotCities = '/api/v2/crm/hubspot/cities',
  HubspotStates = '/api/v2/crm/hubspot/states',
  NylasAccount = '/api/v2.0/nylas/account',
  NylasContacts = '/api/v2.0/nylas/contacts',
  ContactDetails = '/api/v2.0/UserContact/:id',
  ContactNotes = '/api/v2.0/UserContact/:userContactId/notes',
  ContactNote = '/api/v2.0/UserContact/note',
  ContactNoteById = '/api/v2.0/UserContact/note/:id'
}
